import { render, staticRenderFns } from "./MSICertificate.vue?vue&type=template&id=f94e594c&scoped=true"
import script from "./MSICertificate.vue?vue&type=script&lang=js"
export * from "./MSICertificate.vue?vue&type=script&lang=js"
import style0 from "./MSICertificate.vue?vue&type=style&index=0&id=f94e594c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f94e594c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
